import App from './App.svelte';
import Head from './head.svelte';

let app;

import * as modal from "./ui/modal/modal.js";

if (typeof global === 'undefined') {
	window.ts_app = {};
	window.ts_app.modal = modal;

	if (document.body.classList.contains("svelte_widget"))
		app = new Head({
			target: document.getElementById("head-widget"), hydrate:true
		});

	else app = new App({
		target: document.getElementById("tradestore_app"), hydrate:true
	});
}
else{
app = new App({
		props:{}, hydrate:true
	});
}




export default app;